import React from 'react';
import NotEnoughPoints from './NotEnoughPoints';
import DateWindowNotOpen from './DateWindowNotOpen';

interface NoRewardsAvailableProps {
  coinTotal: number;
}
const NoRewardsAvailable: React.FC<NoRewardsAvailableProps> = ({
  coinTotal
}) => {
  return (
    <div>
      {coinTotal <= 0 && <NotEnoughPoints />}
      {coinTotal > 0 && <DateWindowNotOpen />}
    </div>
  );
};

export default NoRewardsAvailable;
